import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import styles from './SectorGraph.module.css'

// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const SectorDoughnutChart = ({ data }) => {
    const sectorList = data.sectorCount || [];
    const colorPalette = [
        'rgba(54, 162, 235, 0.6)', 'rgba(255, 206, 86, 0.6)', 'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)', 'rgba(255, 159, 64, 0.6)', 'rgba(255, 99, 71, 0.6)', 'rgba(255, 140, 0, 0.6)',
        'rgba(34, 193, 195, 0.6)', 'rgba(253, 187, 45, 0.6)', 'rgba(70, 130, 180, 0.6)', 'rgba(255, 165, 0, 0.6)',
        'rgba(255, 99, 132, 0.6)', 'rgba(128, 0, 128, 0.6)', 'rgba(0, 255, 255, 0.6)', 'rgba(255, 105, 180, 0.6)', 'rgba(255, 69, 0, 0.6)',
        'rgba(0, 255, 0, 0.6)', 'rgba(255, 0, 0, 0.6)', 'rgba(0, 0, 255, 0.6)', 'rgba(100, 149, 237, 0.6)',
        'rgba(255, 99, 132, 0.6)', 'rgba(186, 85, 211, 0.6)', 'rgba(46, 139, 87, 0.6)', 'rgba(255, 239, 0, 0.6)',
        'rgba(218, 165, 32, 0.6)', 'rgba(0, 0, 139, 0.6)', 'rgba(255, 222, 173, 0.6)', 'rgba(255, 248, 220, 0.6)',
        'rgba(221, 160, 221, 0.6)', 'rgba(144, 238, 144, 0.6)', 'rgba(255, 228, 225, 0.6)', 'rgba(240, 230, 140, 0.6)',
        'rgba(255, 228, 181, 0.6)', 'rgba(240, 128, 128, 0.6)', 'rgba(245, 245, 220, 0.6)', 'rgba(255, 99, 71, 0.6)',
        'rgba(178, 34, 34, 0.6)', 'rgba(0, 128, 0, 0.6)', 'rgba(255, 165, 0, 0.6)', 'rgba(0, 0, 128, 0.6)',
        'rgba(0, 255, 255, 0.6)', 'rgba(127, 255, 212, 0.6)', 'rgba(105, 105, 105, 0.6)', 'rgba(255, 140, 0, 0.6)',
        'rgba(255, 182, 193, 0.6)', 'rgba(144, 238, 144, 0.6)', 'rgba(72, 61, 139, 0.6)', 'rgba(189, 183, 107, 0.6)',
        'rgba(255, 105, 180, 0.6)', 'rgba(0, 0, 255, 0.6)', 'rgba(34, 139, 34, 0.6)', 'rgba(220, 20, 60, 0.6)',
        'rgba(253, 245, 230, 0.6)', 'rgba(255, 222, 173, 0.6)', 'rgba(255, 69, 0, 0.6)', 'rgba(0, 0, 205, 0.6)',
        'rgba(32, 178, 170, 0.6)', 'rgba(255, 165, 0, 0.6)', 'rgba(255, 99, 132, 0.6)', 'rgba(50, 205, 50, 0.6)',
        'rgba(255, 160, 122, 0.6)', 'rgba(250, 128, 114, 0.6)', 'rgba(153, 50, 204, 0.6)', 'rgba(144, 238, 144, 0.6)',
        'rgba(147, 112, 219, 0.6)', 'rgba(255, 228, 181, 0.6)', 'rgba(255, 239, 0, 0.6)', 'rgba(0, 128, 128, 0.6)',
        'rgba(123, 104, 238, 0.6)', 'rgba(255, 182, 193, 0.6)', 'rgba(255, 193, 37, 0.6)', 'rgba(102, 205, 170, 0.6)',
        'rgba(255, 99, 132, 0.6)', 'rgba(238, 130, 238, 0.6)', 'rgba(220, 220, 220, 0.6)', 'rgba(255, 228, 181, 0.6)',
        'rgba(72, 61, 139, 0.6)', 'rgba(107, 142, 35, 0.6)', 'rgba(255, 218, 185, 0.6)', 'rgba(0, 255, 255, 0.6)'
    ];
    // Prepare data for the chart
    const config = {
        labels: sectorList.map(sector => sector._id),
        datasets: [
            {
                label: 'Sector Distribution',
                data: sectorList.map(sector => sector.count),
                backgroundColor: colorPalette.slice(0, sectorList.length),
                borderColor: colorPalette.slice(0, sectorList.length),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Sector Distribution',
            },
        },
    };

    return (
        <div className={styles.chart_wrap}>
            <Doughnut data={config} options={options} />
        </div>
    )
};

export default SectorDoughnutChart;